<template>
  <div class="global-layout">
    <div class="auth-lang-switcher">
      <AuthLanguageSwitcher />
    </div>
    <v-main>
      <v-container fluid class="h-full">
        <router-view :key="$route.path" />
      </v-container>
      <Notification/>
      <NotificationDialog/>
    </v-main>
  </div>
</template>
<script>
import Notification from '@/components/Notification'
import NotificationDialog from '@/components/NotificationDialog'
import AuthLanguageSwitcher from '@/components/AuthLanguageSwitcher'

export default {
  name: 'GlobalLayout',
  components: {
    AuthLanguageSwitcher,
    Notification,
    NotificationDialog
  },
  data () {
    return {}
  },
  created () {
    const recaptcha = this.$recaptchaInstance
    if (recaptcha) { recaptcha.hideBadge() }
  }
}
</script>

<style lang="scss" scoped>
.global-layout {
  position: relative;
  background-color: var(--v-background-base);
}

.auth-lang-switcher {
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 10;
}
</style>
